import {
    endOfDay,
    endOfWeek,
    isAfter,
    isBefore,
    isThisWeek,
    isToday,
} from 'date-fns';

import { ViewGroup } from '../model/view-group.model';
import { ViewTaskItem } from '../model/view-task-item.model';

export function groupItems(
    groups: ViewGroup[],
    tasks: ViewTaskItem[],
): ViewGroup[] {
    const today = endOfDay(new Date());
    const week = endOfWeek(new Date());

    const nextGroups = [...groups];

    nextGroups[0].tasks = tasks.filter(
        (task) =>
            task.completed !== true &&
            task.dueDateTime != null &&
            (isToday(task.dueDateTime) || isBefore(task.dueDateTime, today)),
    );

    nextGroups[1].tasks = tasks.filter(
        (task) =>
            task.completed !== true &&
            task.dueDateTime != null &&
            isAfter(task.dueDateTime, today) &&
            isThisWeek(task.dueDateTime),
    );

    nextGroups[2].tasks = tasks.filter(
        (task) =>
            task.completed !== true &&
            (task.dueDateTime == null || isAfter(task.dueDateTime, week)),
    );

    nextGroups[3].tasks = tasks.filter((task) => task.completed === true);

    return nextGroups;
}
